import React, { useEffect, useMemo, useState, FC } from 'react';
import cls from 'classnames';

import { Modal as ModalComponent } from 'src/shoppe/elements/Modal';

import Image from './atoms/Image';
import Logo from './atoms/Logo';
import Form from './molecules/Form';
import Success from './molecules/Success';

import styles from './index.module.sass';

interface ModalProps {
  discountLabel: string;
  image: {
    desktop?: string;
    mobile?: string;
  };
  logo?: string;
  merchant?: string;
}

const Modal: FC<ModalProps> = ({ discountLabel, image, logo, merchant }) => {
  const [ isOpen, setIsOpen ] = useState<boolean>( false );
  const [ step, setStep ] = useState<number>( 1 );

  useEffect(() => {
    const delayedOpen = setTimeout(() => {
      setIsOpen( true );
    }, 2000 );

    return () => {
      clearTimeout( delayedOpen );
      setIsOpen( false );
    };
  }, [ setIsOpen ]);

  const withImage = useMemo(() => !!image.desktop || !!image.mobile, [ image ]);

  return (
    <ModalComponent
      open={isOpen}
      closeBtn
      closeClass={cls( styles.close, {
        [styles['with-image']]: withImage,
      })}
      containerClass={cls( styles.modal, {
        [styles['with-image']]: withImage,
      })}
      overlayClass={`${styles.overlay} spec__first-order-promotion`}
      onClick={() => setIsOpen( false )}
    >
      {withImage && <Image desktop={image.desktop} mobile={image.mobile} />}

      <div
        className={cls( styles.container, {
          [styles['with-image']]: withImage,
        })}
      >
        <Logo alt={merchant} src={logo} />

        <div className={styles.steps}>
          <Form
            discountLabel={discountLabel}
            step={step}
            onDecline={() => setIsOpen( false )}
            onStep={() => setStep(( state ) => state + 1 )}
          />

          {step === 3 && <Success onClose={() => setIsOpen( false )} />}
        </div>
      </div>
    </ModalComponent>
  );
};

export default Modal;
